import axios from 'axios';
import ApiUrl from './config';

export async function finishTournament(id: number): Promise<void> {
  await axios.post(`${ApiUrl}/api/Tournament/FinishTournament`, null, { params: { id } });
}

export async function reopenTournament(id: number): Promise<void> {
  await axios.post(`${ApiUrl}/api/Tournament/ReopenTournament`, null, { params: { id } });
}
